import {CSSProperties, JSX} from "react";

import "./styles/star-rating.scss";

interface StarRatingProps {
    name: string | number; // Reviewer name
    rating?: number; // Rating value from 0 to 5
    date?: string; // Review date
    className?: string;
    size?: "small" | "medium" | "large";
}

export function StarRating({name, rating = 0, date, className = "", size = "medium"}: StarRatingProps): JSX.Element {
    // Ensure rating is between 0 and 5
    const normalizedRating = Math.max(0, Math.min(5, rating));

    return (
        <div className={`star-rating ${className}`}>
            <div className="star-rating__content">
                <div className={`star-rating__stars stars--${size}`} style={{"--rating": normalizedRating} as CSSProperties} />
                {!!name && <span className="star-rating__name">{name}</span>}
                {date && (
                    <>
                        <span className="star-rating__divider"></span>
                        <span className="star-rating__date">{date}</span>
                    </>
                )}
            </div>
        </div>
    );
}
